import { useTranslation } from "react-i18next";
import type { ListedGroup } from "../../../api/access/accessModel";

/** Whom a group reaches, and where a pinned group stays: "2 people · always on top". */
export default function GroupSize({ group }: { group: ListedGroup }) {
  const { t } = useTranslation();
  if (group.system === "everyone") return <>{`${t("access.everyoneWithAccount")} · ${t("access.alwaysLast")}`}</>;
  const size = t("access.peopleCount", { count: group.peopleIds.length });
  const pinnedTop = group.system === "administrators" || group.system === "project_administrators";
  return <>{pinnedTop ? `${size} · ${t("access.alwaysOnTop")}` : size}</>;
}
